
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonSpinner,
  IonText,
  IonLabel,
  IonList,
  IonItem,
  IonIcon,
  IonFab,
  IonFabButton,
} from "@ionic/vue";
import { refresh } from "ionicons/icons";

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import apiPresenze from "../services/presenze";
import { openToast } from "../services/toast";

import moment from "moment";

export default {
  name: "ElencoPresenze",
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonPage,
    IonSpinner,
    IonText,
    IonLabel,
    IonList,
    IonItem,
    IonIcon,
    IonFab,
    IonFabButton,
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const presenze = ref([]);
    const userID = JSON.parse(localStorage.getItem("userInfo")).users_id;

    /**
     *
     * Print name and last name or customer company based on condition
     *
     */
    // const riferimentoCliente = computed(() => {
    //   return (intervento) => {
    //     //console.log(intervento);
    //     if (
    //       (intervento.customers_name != null &&
    //         intervento.customers_last_name != null) ||
    //       (intervento.customers_name != "" &&
    //         intervento.customers_last_name != "")
    //     ) {
    //       return `${intervento.customers_name} ${intervento.customers_last_name}`;
    //     } else {
    //       return `${intervento.customers_company}`;
    //     }
    //   };
    // });

    function riferimentoCliente(presenza) {
      if (presenza.customers_company) {
        return `${presenza.customers_company}`;
      } else {
        return `${presenza.customers_name} ${presenza.customers_last_name}`;
      }
    }

    /**
     *
     * Return '-' if a customer field is null
     *
     */
    function checkField(field) {
      if (field == null) {
        return " ";
      } else {
        return " - " + field;
      }
    }

    /**
     *
     * Format date from YYYY/MM/DD HH:mm:ss to DD/MM/YYY
     *
     */
    function dateFormat(date) {
      if (moment.isDate(new Date(date))) {
        return moment(date).format("DD/MM/YYYY");
      } else {
        return "-";
      }
    }

    /**
     *
     * Passing id to retrive detail in InterventoDetail page
     *
     */
    function openDetail(id: string) {
      router.push(`tab2/${id}`);
    }

    function getPresenze() {
      //console.log("getPresenze");
      loading.value = true;
      apiPresenze
        .getPresenze(userID)
        .then((response) => {
          presenze.value = response;
        })
        .catch((error) => {
          //error.value = true;
          openToast("Errore durante la richiesta degli interventi", "danger");
          console.error(error);
        })
        .finally(() => {
          loading.value = false;
        });
    }

    onMounted(() => {
      //GET INTERVENTI DATA
      getPresenze();
    });

    return {
      loading,
      presenze,
      riferimentoCliente,
      dateFormat,
      refresh,
      openDetail,
      getPresenze,
      checkField,
    };
  },
};
